module.exports = __webpack_public_path__ + "static/media/ic_next_arrow.b23fe362.svg";